/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { RecognitionAlternative } from './recognition-alternative';

/**
 * A WrittenFormRecognitionResult describes a simple object which consists solely of \'word\' type entries with a start and end time. It can occur only inside the written_form property of a full RecognitionResult\"
 * @export
 * @interface WrittenFormRecognitionResult
 */
export interface WrittenFormRecognitionResult {
  /**
   *
   * @type {Array<RecognitionAlternative>}
   * @memberof WrittenFormRecognitionResult
   */
  alternatives: Array<RecognitionAlternative>;
  /**
   *
   * @type {number}
   * @memberof WrittenFormRecognitionResult
   */
  end_time: number;
  /**
   *
   * @type {number}
   * @memberof WrittenFormRecognitionResult
   */
  start_time: number;
  /**
   * What kind of object this is. See #/Definitions/RecognitionResult for definitions of the enums.
   * @type {string}
   * @memberof WrittenFormRecognitionResult
   */
  type: WrittenFormRecognitionResultTypeEnum;
}

export const WrittenFormRecognitionResultTypeEnum = {
  Word: 'word',
} as const;

export type WrittenFormRecognitionResultTypeEnum =
  (typeof WrittenFormRecognitionResultTypeEnum)[keyof typeof WrittenFormRecognitionResultTypeEnum];
